import { createRouter, createWebHistory } from 'vue-router'

import QuoteOverviewPage from '@/pages/business-to-business/QuoteOverviewPage.vue'
import ConfiguratorCallbackPage from '@/pages/business-to-business/ConfiguratorCallbackPage.vue'
import PurchaseOrderOverviewPage from '@/pages/purchase-order/PurchaseOrderOverviewPage.vue'
import PurchaseOrderPage from '@/pages/purchase-order/PurchaseOrderPage.vue'
import ChangeOrderOverviewPage from '@/pages/change-order/ChangeOrderOverviewPage.vue'
import ChangeOrderPage from '@/pages/change-order/ChangeOrderPage.vue'
import BulkChangeOrderPage from '@/pages/bulk-change-order/BulkChangeOrderPage.vue'
import EstablishmentSelectionPage from '@/pages/EstablishmentSelectionPage.vue'
import authenticationService from '@/services/authenticationService'
import navigationHistoryService from '@/services/navigationHistoryService'
import CustomerConfigurationPageWrapper from '@/pages/CustomerConfigurationPageWrapper.vue'
import VcrPage from '@/pages/vcr/VcrPage.vue'
import PrintPage from '@/pages/PrintPage.vue'
import InstructionsPage from '@/pages/instructions/InstructionsPage.vue'
import FaqPage from '@/pages/FaqPage.vue'
import UnsuccessfulLoginPage from '@/pages/unsuccessful-login-page/UnsuccessfulLoginPage.vue'
import AuthorizationModulePage from '@/pages/authorization-module/AuthorizationModulePage.vue'
import store from '@/store/store'
import { setCookie } from '@/helpers/cookieHelper'
import BulkFuturePricesPage from '@/pages/bulk-future-prices/BulkFuturePricesPage.vue'
import ConfigurationInvestigationPage from '@/pages/configuration-investigation/ConfigurationInvestigationPage.vue'
import WarningBannerPage from '@/pages/warningbanner/WarningBannerPage.vue'
import MediaPage from '@/pages/media/MediaPage.vue'
import SettingsPage from '@/pages/settings/SettingsPage.vue'
import AddendaPage from '@/pages/addenda/AddendaPage.vue'
import ReportsPage from '@/pages/reports/ReportsPage.vue'
import LeaseMappingPage from '@/pages/leasemapping/LeaseMappingPage.vue'
import { showsVcr, VCR_META, VCR_PRINT_META } from '@/router/guards'

const routes = [
  {
    name: 'establishment-selection',
    path: '/vestigingkeuze',
    component: EstablishmentSelectionPage,
  },
  {
    name: 'establishment-selection-short',
    path: '/',
    component: EstablishmentSelectionPage,
  },

  // cstType = b2b or b2c
  {
    name: 'quote-overview-page',
    path: '/:cstType/vestiging/:establishmentId?',
    component: QuoteOverviewPage,
    props: true,
  },

  // cstType = po
  {
    name: 'purchase-orders-page',
    path: '/po/vestiging/:establishmentId/purchase-order',
    component: PurchaseOrderOverviewPage,
    props: true,
  },
  {
    name: 'purchase-order-page',
    path: '/po/vestiging/:establishmentId/purchase-order/:purchaseOrderId',
    component: PurchaseOrderPage,
    props: true,
  },
  {
    name: 'new-purchase-order-page',
    path: '/po/vestiging/:establishmentId/new-purchase-order/:configurationCode',
    component: PurchaseOrderPage,
    props: true,
  },
  {
    name: 'change-orders-page',
    path: '/po/vestiging/:establishmentId/change-order',
    component: ChangeOrderOverviewPage,
    props: true,
  },
  {
    name: 'change-order-page',
    path: '/po/vestiging/:establishmentId/change-order/:changeOrderId',
    component: ChangeOrderPage,
    props: true,
  },
  {
    name: 'new-change-order-page',
    path: '/po/vestiging/:establishmentId/new-change-order/:komNumber/:komYear?',
    component: ChangeOrderPage,
    props: true,
  },
  {
    name: 'bulk-change-order-page',
    path: '/po/vestiging/:establishmentId/bulk-change-order/:bulkChangeOrderId',
    component: BulkChangeOrderPage,
    props: true,
  },
  {
    name: 'bulk-future-prices-page',
    path: '/toekomstige-prijzen/:jobId?',
    component: BulkFuturePricesPage,
    props: true,
  },
  {
    name: 'configuration-page',
    path: '/:cstType/vestiging/:establishmentId/quote/:quoteId',
    component: CustomerConfigurationPageWrapper,
  },
  // A new route has been added for a specific client. Upon opening, a cookie will be set to enable the application of specific CSS styling for that client.
  {
    name: 'fix-fonts',
    path: '/fix-fonts',
    component: EstablishmentSelectionPage,
    redirect: (to) => {
      setCookie('use-legacy-style', '1', true)
      document.body.classList.add(`theme-skoda-fix`)
      return { path: '/' }
    },
  },
  {
    name: 'configurator-callback',
    path: '/:cstType/vestiging/:establishmentId/configuratie',
    component: ConfiguratorCallbackPage,
  },
  {
    name: 'new-configuration-page-no-config',
    path: '/:cstType/vestiging/:establishmentId/new-quote',
    component: CustomerConfigurationPageWrapper,
  },
  {
    name: 'new-configuration-page',
    path: '/:cstType/vestiging/:establishmentId/configuratie/:configurationCode',
    component: CustomerConfigurationPageWrapper,
  },
  {
    name: 'new-shopping-cart-page',
    path: '/:cstType/vestiging/:establishmentId/cartId/:cartId',
    component: CustomerConfigurationPageWrapper,
  },
  // using stockcar-id
  {
    name: 'new-stockcar-page',
    path: '/:cstType/vestiging/:establishmentId/voorraadauto/:stockCarId',
    component: CustomerConfigurationPageWrapper,
  },
  // using komnumber
  {
    name: 'new-stockcar-komnumber-page',
    path: '/:cstType/vestiging/:establishmentId/komnummer/:komnummer',
    component: CustomerConfigurationPageWrapper,
  },
  // using commissionYear and commissionNumber
  {
    name: 'new-stockcar-commission-number-page',
    path: '/:cstType/vestiging/:establishmentId/commissionNumber/:commissionNumber/commissionYear/:commissionYear',
    component: CustomerConfigurationPageWrapper,
  },

  { name: 'b2b-page', path: '/b2b', component: QuoteOverviewPage },
  { name: 'b2c-page', path: '/b2c', component: QuoteOverviewPage },

  {
    name: 'vcr-page',
    path: '/:cstType/vestiging/:establishmentId/quote/:quoteId/voorcalculatorisch-resultaat',
    component: VcrPage,
    meta: VCR_META,
  },
  {
    name: 'print-page',
    path: '/:cstType/vestiging/:establishmentId/quote/:quoteId/print/:page',
    component: PrintPage,
    meta: VCR_PRINT_META,
  },

  {
    name: 'instructions',
    path: '/instructies',
    component: InstructionsPage,
  },
  {
    name: 'faq',
    path: '/faq',
    component: FaqPage,
  },
  {
    name: 'video-instructions',
    path: '/instructies/video',
    redirect: { name: 'instructions', hash: '#videos' },
  },
  {
    name: 'manuals',
    path: '/handleidingen',
    redirect: { name: 'instructions', hash: '#manuals' },
  },

  {
    name: 'unsuccessful-login-page',
    path: '/unsuccessful-login-page',
    component: UnsuccessfulLoginPage,
  },
  {
    name: 'authorization-module',
    path: '/authorization-module',
    component: AuthorizationModulePage,
  },
  {
    name: 'warning-banner',
    path: '/warning-banner',
    component: WarningBannerPage,
  },
  {
    name: 'addenda',
    path: '/addenda',
    component: AddendaPage,
  },
  {
    name: 'reports',
    path: '/rapportages',
    component: ReportsPage,
  },
  {
    name: 'lease-mapping',
    path: '/lease-mapping',
    component: LeaseMappingPage,
    meta: { requiredPermission: 'manage_lease_mapping' },
  },
  {
    name: 'configuration-investigation',
    path: '/configuratie-onderzoeken',
    component: ConfigurationInvestigationPage,
    meta: { requiredPermission: 'investigate_configuration' },
  },
  {
    name: 'media-page',
    path: '/media/:establishmentId?',
    component: MediaPage,
    props: true,
  },
  {
    name: 'settings',
    path: '/instellingen',
    component: SettingsPage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Guards return their result rather than calling next(): the callback is
// deprecated in vue-router 5, and an async guard that declares it but never
// calls it (the login branch below) is rejected outright.
router.beforeEach(async (to, from) => {
  // Track navigation history for breadcrumbs (skip initial page load)
  if (from.name && from.name !== to.name) {
    navigationHistoryService.addToHistory(from)
  }

  if (store.getters['user/isAuthenticated'] || to?.name == 'unsuccessful-login-page') {
    // Opt-in per-route permission guard: only routes declaring meta.requiredPermission are gated.
    // rights are set atomically together with authentication, so no loading race here.
    if (
      to.meta?.requiredPermission &&
      !store.state.user.rights.includes(to.meta.requiredPermission)
    ) {
      return { name: 'establishment-selection' }
    }

    // dealer settings are loaded before the router is installed (main.js), so no race here either
    if (showsVcr(to) && !store.getters['user/canViewVcr']) {
      return { name: 'establishment-selection' }
    }

    return true
  }

  // login() points location.href at Okta, so this navigation must not go
  // through. Aborting it is what never calling next() used to amount to.
  await authenticationService.login()
  return false
})

export default router
